<div class="p-grid">
  <p-card class="p-col p-xl-11" header="History for {{label}}">
    <div style="margin-bottom: 1em">
      <p-accordion [multiple]="true">
        @for (change of filteredChangeHistory; track `${change.entityId}-${change.timestamp.toISO()}`) {
          <p-accordion-panel [value]="change.timestamp.toISO()">
            <p-accordion-header>
              <div class="history-accordion-header">
                <span class="history-accordion-entity-action">
                  {{change.dataType}}
                  <p-chip
                    label="{{ change.action | titlecase }}"
                    styleClass="text-small history-accordion-chip"
                    aria-label="Type of change"
                  ></p-chip>
                </span>
                <time
                  class="text-small"
                  [dateTime]="change.timestamp.toISO()"
                  aria-label="Date and time of change"
                  [pTooltip]="format(change.timestamp)?.toString() ?? ''"
                  >
                  {{ change.timestamp.toRelative() }}
                </time>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <tr>
                <td class="key">
                  Database Id
                </td>
                <td class="value">
                  {{ change.entityId }}
                </td>
              </tr>
              @for (item of change.history | keyvalue ; track item) {
                <tr>
                  <td class="key">{{changeForeignKeyNameSuffix(item.key) | camelCase}}</td>
                  <td class="value">{{format(item.value)}}</td>
                </tr>
              }
              <tr>
                <td class="key">
                  Last Changed By
                </td>
                <td class="value">
                  {{ change.userId }}
                </td>
              </tr>
              <tr>
                <td class="key">
                  Last Changed
                </td>
                <td class="value">
                  {{ format(change.timestamp) }}
                </td>
              </tr>
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
  </p-card>
  <div class="p-col p-xl-1">
    @if (changeHistory?.length > 0) {
      <button pButton (click)="exportToExcel()" title="Export" icon="pi pi-file-excel">
      </button>
    }

    @if (actionTemplate) {
      <ng-container [ngTemplateOutlet]="actionTemplate"></ng-container>
    }
  </div>
</div>
